export default {
  enterpriseKind: null,
};
